export default __webpack_public_path__ + "static/media/humanResource.fb1e22c9.jpg";